import { getOrderById, getOrders } from '@api/order';
import { OrderSummaryContainer } from '@components/container';
import { OrderStatus } from '@components/contants';
import { TOrder, TStore } from '@components/types';
import { requestLogin } from '@core/utils';
import { message } from 'antd';
import { motion } from "framer-motion";
import Cookies from 'js-cookie';
import { ChevronLeft, Package2, X } from 'lucide-react';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import DetailOrder from './detailorder';

type Props = {
    setIsMyOrdersOpen?: Function
    isMyOrdersOpen?: boolean
    transactionId?: string
    mode?: string
    store?: TStore
    maxWidth?: string
}

const MyOrders: React.FC<Props> = ({ setIsMyOrdersOpen, isMyOrdersOpen, transactionId, mode, store, maxWidth }) => {
    const [orders, setOrders] = useState<TOrder[]>();
    const [currentOrders, setCurrentOrders] = useState<TOrder[]>();
    const [orderStage, setOrderStage] = useState("myorders")
    const [detailOrder, setDetailOrder] = useState<TOrder>({})
    const router = useRouter()


    useEffect(() => {
        if (mode === "status") {
            setOrderStage("orderstatus")
        }
    }, [mode])

    useEffect(() => {
        if (transactionId?.length > 0) {
            getOrders([], [], transactionId, Cookies.get('uid'), Cookies.get('sid'), store?.id).then((res) => {
                setCurrentOrders(res);
            })
        }
    }, [transactionId])

    const fetchOrders = async (RefressMessage:boolean=false) => {
        await getOrders(store?.storemeta?.settings?.hide_completed_orders ? [OrderStatus.CREATED, OrderStatus.PROCESSING, OrderStatus.DISPATCHED] : [], [], null, Cookies.get('uid'), Cookies.get('sid'), store?.id)?.then((result) => {
            if (result.length == 0 && typeof localStorage != "undefined" && localStorage.getItem("orderId")) {
                getOrderById(localStorage.getItem("orderId")).then((res) => {
                    setOrders([res])
                })
            } else {
                setOrders(result)
            }
            if(RefressMessage){
                message.success("Orders Refreshed");
            }
        })?.catch((e) => {
            if (e.response?.status === 401) {
                requestLogin(router.asPath);
            }
        });
    }

    useEffect(() => {
        if (isMyOrdersOpen) {
            fetchOrders();
        }
    }, [isMyOrdersOpen]);
    
    useEffect(() => {
        if (isMyOrdersOpen) {
          // Lock scrolling when cart is open
          document.body.style.overflow = 'hidden';
        } else {
          // Restore scrolling when cart is closed
          document.body.style.overflow = 'unset';
        }
    
        // Cleanup function to ensure scroll is restored when component unmounts
        return () => {
          document.body.style.overflow = 'unset';
        };
      }, [isMyOrdersOpen]);


    return (
        <div className="fixed -bottom-120 w-full z-40 flex flex-col justify-center">
            <motion.div className={`grid justify-items-stretch ${maxWidth?.length > 0 ? maxWidth : ""}`}
                animate={isMyOrdersOpen ? "open" : "closed"}
                variants={{
                    open: { x: 0, y: "-100%" },
                    closed: { y: "0%" },
                }}
                transition={{ ease: "easeOut", duration: 0.5 }}
            >
                <div
                style={{background:store?.storemeta?.settings?.shop_page_theme?.bg || "#0F6E56"}}
                className="relative flex flex-col gap-2 justify-start items-center w-full h-120 z-20 rounded-t-3xl pb-12 shadow-2xl">
                    <div className="w-10 h-1 rounded-full bg-white/20 mt-2"></div>
                    <div className="flex flex-row">
                        {
                            orderStage != "myorders" &&
                            <button
                            type="button"
                            className="absolute top-3 left-4 text-neutral-300 p-1.5 rounded-full hover:bg-white/10 transition-colors cursor-pointer"><ChevronLeft  style={{color:store?.storemeta?.settings?.shop_page_theme?.text || ""}}  className="text-lg text-white" onClick={(e) => { setOrderStage("myorders") }} /></button>
                        }
                        <div
                        style={{color:store?.storemeta?.settings?.shop_page_theme?.text || ""}}
                        className="pt-2 pb-2 font-manrope text-base text-neutral-50 font-semibold">My Orders</div>
                        <button
                        type="button"
                        style={{color:store?.storemeta?.settings?.shop_page_theme?.text || ""}}
                        className="absolute top-3 right-4 text-neutral-300 p-1.5 rounded-full hover:bg-white/10 transition-colors cursor-pointer"><X size={20} onClick={(e) => { if (transactionId?.length > 0 && mode === "status") { setIsMyOrdersOpen(); setOrderStage("myorders"); router.push(`/shop/${store?.id}`) } else { setIsMyOrdersOpen(); setOrderStage("myorders") } }} /></button>
                    </div>
                    {
                        orderStage === "myorders" &&
                        <div className="flex w-full gap-2 overflow-y-scroll small-scrollbar">
                            <div className="grid px-4 gap-4 pb-20 mx-auto w-full h-full">
                                {orders?.length == 0
                                    ?
                                    <div className="flex flex-col gap-2 justify-center items-center h-full w-full py-10">
                                        <div className="flex items-center justify-center w-20 h-20 rounded-full bg-white/10">
                                            <Package2 className="w-9 h-9 text-white" strokeWidth={1.5} />
                                        </div>
                                        <div>
                                            <h3 className="flex font-manrope justify-center text-base font-semibold text-white pt-2">
                                                No orders right now
                                            </h3>
                                            <p className="text-sm text-neutral-200 text-center">Start shopping to see your orders here.</p>
                                        </div>
                                    </div>
                                    :
                                    <OrderSummaryContainer maxWidth={maxWidth} noLink={true} orders={orders} setOrderStage={setOrderStage} setDetailOrder={(order: TOrder) => { setDetailOrder(order) }} reloadFunction={fetchOrders} />
                                }
                            </div>
                        </div>
                    }
                    {
                        orderStage === "orderstatus" &&
                        <DetailOrder currentOrders={currentOrders} transactionId={transactionId} storeId={store?.id} />
                    }
                    {
                        orderStage === "detailorder" &&
                        <DetailOrder currentOrders={[detailOrder]} />
                    }
                </div>
            </motion.div>
        </div>
    )
}

export default MyOrders